// Manually update this map with brief release notes keyed by the deployed web version.
const releaseNotesMap: Record<string, string[]> = {
  // '1.2.3': ['Short description of the release.'],
  '1.30.0': [
    'New! Rollo Rewards: Earn discounts, perks, and exclusive rewards.',
    'New! Bank payments support.',
    'Improved email templates with multiple recipient support.',
    'Various performance improvements and bug fixes.',
  ],
  '1.31.0': ['Enhanced Rewards experience.', 'Various performance improvements and bug fixes.'],
  '1.32.0': [
    'New! Trusted login: Faster, more secure sign-in that recognizes your trusted devices.',
    'New! Smarter order tracking: Pending orders now refresh automatically.',
    'New! Unified Search: Find any order or shipment by searching Orders and Shipped at once.',
    'New! Order update history: See every change made to an order and who made it, right from the order details page.',
    'New! Create a shipment directly from your Contacts.',
    'Get notified the moment you unlock a Rewards badge.',
    'Sync "Mark as Shipped" status back to your marketplace.',
    'Streamlined Rewards: Redeem your perks in fewer steps.',
    'Various performance improvements and bug fixes.',
  ],
};

export const getReleaseNotes = (version?: string | null) => {
  if (!version) return null;
  return releaseNotesMap[version] || null;
};

export default releaseNotesMap;
